import { defineComponent as r, computed as o, openBlock as i, createElementBlock as a, createElementVNode as e, toDisplayString as d, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], u = /* @__PURE__ */ e("mask", { id: "ad40e8a0-e8b5-439b-ad56-487ff7c5f4b4" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#ad40e8a0-e8b5-439b-ad56-487ff7c5f4b4)" }, p = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "M144.8 0h222.4l32 260-32 252H144.8l-32.1-256z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#496e2d",
  d: "M0 0h144.8v512H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M367.2 0H512v512H367.2z"
}, null, -1), x = /* @__PURE__ */ e("path", {
  fill: "#496e2d",
  d: "m256.1 167 22.1 68h71.5L292 277l22 68-57.8-42-57.9 42 22.1-68-57.8-42H234z"
}, null, -1), w = { fill: "none" }, b = ["r"], B = /* @__PURE__ */ r({
  __name: "sn",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const t = c, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), n = o(() => 256 + t.strokeWidth / 2);
    return (y, z) => (i(), a("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      u,
      e("g", m, [
        t.flagName ? (i(), a("title", p, d(t.flagName), 1)) : f("", !0),
        k,
        v,
        g,
        x
      ]),
      e("g", w, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, b)
      ])
    ], 8, h));
  }
});
export {
  B as default
};
//# sourceMappingURL=sn-48ffbcf0.js.map
